import Breadcrumbs from './Breadcrumbs';

import styles from './PageTitle.module.scss';

interface Props {
  breadcrumbs?: Array<[string, string] | string>;
  title?: string;
}

const PageTitle: React.FC<Props> = ({ breadcrumbs, title }) => {
  return (
    <div className={styles.pageTitle}>
      <div className="container">
        {!!breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
        {!!title && <h1>{title}</h1>}
      </div>
    </div>
  );
};
export default PageTitle;
